import PropTypes from "prop-types";
import { Box, useTheme } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookmark as regularBookmark } from "@fortawesome/pro-regular-svg-icons";
import { faBookmark as solidBookmark } from "@fortawesome/pro-solid-svg-icons";

const BookmarkGlyph = ({ icon, color }) => (
  <FontAwesomeIcon icon={icon} color={color} />
);

BookmarkGlyph.propTypes = {
  icon: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
};

const BookmarkIcon = ({ checked, iconPixels }) => {
  const theme = useTheme();

  return (
    <Box
      data-testid="bookmark-icon"
      sx={{
        position: "relative",
        width: iconPixels,
        height: iconPixels,
        lineHeight: 0,
        "& svg": {
          fontSize: `${iconPixels}px`,
          position: "absolute",
          inset: 0,
        },
      }}
    >
      {!checked && (
        <BookmarkGlyph
          icon={solidBookmark}
          color={theme.palette.background.paper}
        />
      )}
      <BookmarkGlyph
        icon={checked ? solidBookmark : regularBookmark}
        color={theme.palette.brandText}
      />
    </Box>
  );
};

BookmarkIcon.propTypes = {
  checked: PropTypes.bool.isRequired,
  iconPixels: PropTypes.number.isRequired,
};

export default BookmarkIcon;
